import IconButton from '@material-ui/core/IconButton';
import SettingsIcon from '@material-ui/icons/Settings';
import React from 'react';
import { useNavigateAdminTable } from './AdminTable';
import Tooltip from '@material-ui/core/Tooltip';

interface Props {}

const AdminButton = (props: Props) => {
  const navigateToAdmin = useNavigateAdminTable();

  return (
    <Tooltip title="ボックス管理">
      <IconButton onClick={navigateToAdmin}>
        <SettingsIcon />
      </IconButton>
    </Tooltip>
  );
};

export default AdminButton;
